export default __webpack_public_path__ + "static/media/labReportOn.627ae920.svg";